import { jsx as _jsx } from "react/jsx-runtime";
import { LinkList } from "@cinch-nx/shared-ui";
import styles from "./links-section.module.css";
export var LinksSection = function(param) {
    var title = param.title, links = param.links;
    var models = links === null || links === void 0 ? void 0 : links.map(function(p) {
        return {
            url: p.url.url,
            text: p.text
        };
    });
    return /*#__PURE__*/ _jsx("section", {
        className: styles.container,
        children: /*#__PURE__*/ _jsx(LinkList, {
            title: title,
            linkItems: models
        })
    });
};
